import { type MithrilVNode } from '../../mithril';
import { CurrentState } from '../../state/page.state';
import { LineDrawPopup } from './line.draw.popup';

/** Renders the app-global line-draw popup. Drop into a (positioned) map container so it anchors over that map. */
export const GlobalLineDrawPopup = {
	view(): MithrilVNode | null {
		if (!CurrentState.LineDraw.isActive) {
			return null;
		}
		return LineDrawPopup.view({
			onComplete: () => CurrentState.LineDraw.complete(),
			onCancel: () => CurrentState.LineDraw.cancel(),
			lineDrawState: CurrentState.LineDraw.state,
		});
	},
};
